export function formatTotalReadingTime(value: any) {
    if (value === undefined || value === null || isNaN(value)) {
        return;
    }

    if (value < 3600) {
        return Math.round(value / 60) + ' min';
    }

	return (Math.round(value / 3600 * 10) / 10) + ' hrs';
}

export default formatTotalReadingTime;
